import { useState } from 'react'
import { InputProps, Input } from '@/components/ui'
import { cn } from '@/lib/utils'

// TODO: Questo componente è orribile
export const PasswordInput = ({ ref, ...props }: React.ComponentPropsWithRef<'input'> & InputProps) => {
  const [isPasswordRevealed, setIsPasswordRevealed] = useState(false)
  const toggleIsPasswordRevealed = () => setIsPasswordRevealed(!isPasswordRevealed)
  const { className, ...rest } = props
  return (
    <div className='flex'>
      <Input
        autoComplete='new-password'
        {...rest}
        className={cn(className, `rounded-br-none rounded-tr-none border border-r-0 border-gray-200 px-2`)}
        ref={ref}
        type={isPasswordRevealed ? `text` : `password`}
      />
      <button
        type='button'
        className='rounded rounded-bl-none rounded-tl-none border border-l-0 border-gray-200 px-2'
        aria-label={isPasswordRevealed ? `Hide password` : `Show password`}
        aria-controls={props.id}
        onClick={toggleIsPasswordRevealed}
      >
        <span className='text-sm'>{isPasswordRevealed ? `Hide` : `Show`}</span>
      </button>
    </div>
  )
}

PasswordInput.displayName = `PasswordInput`
